import { render } from "./WarehouseList.vue?vue&type=template&id=860a2650"
import script from "./WarehouseList.vue?vue&type=script&lang=js"
export * from "./WarehouseList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__